import type { Subscription } from '../../models/Subscription';
import { apiClient } from '../api/apiClient';
import { delay, readCollection, seedCollection } from './dataverseClient';
import { subscriptionsSeed } from './mockData';

const ENTITY = 'cr_crm_subscription';

class SubscriptionService {
  private ensureSeed(): void {
    seedCollection(ENTITY, subscriptionsSeed);
  }

  async list(clientId?: string): Promise<Subscription[]> {
    if (apiClient.isConfigured()) {
      const qs = clientId ? `?customerId=${clientId}` : '';
      const res = await apiClient.get<{ totalCount: number; items: Subscription[] } | Subscription[]>(
        `/api/subscriptions${qs}`
      );
      return Array.isArray(res) ? res : (res as { items: Subscription[] }).items ?? [];
    }
    this.ensureSeed();
    await delay();
    return readCollection<Subscription>(ENTITY)
      .filter((s) => (clientId ? s.cr_crm_clientid === clientId : true))
      .sort((a, b) => (a.cr_crm_renewaldate ?? '').localeCompare(b.cr_crm_renewaldate ?? ''));
  }

  async getExpiringSoon(days: number): Promise<Subscription[]> {
    if (apiClient.isConfigured()) {
      const res = await apiClient.get<{ totalCount: number; items: Subscription[] } | Subscription[]>(
        `/api/subscriptions?expiringSoonDays=${days}`
      );
      return Array.isArray(res) ? res : (res as { items: Subscription[] }).items ?? [];
    }
    this.ensureSeed();
    await delay();
    const now = new Date();
    const limit = new Date();
    limit.setDate(limit.getDate() + days);
    return readCollection<Subscription>(ENTITY).filter(
      (s) => s.cr_crm_renewaldate
        ? new Date(s.cr_crm_renewaldate) >= now && new Date(s.cr_crm_renewaldate) <= limit
        : false
    );
  }
}

export const subscriptionService = new SubscriptionService();
